import { requestModuleUse } from 'src/store'

export const CompStoreModule = {
  abstract: true,
  async beforeCreate () {
    if (!this.$options.storeModule) {
      throw new Error(`Component ${this.$options.name} is tring to extent CompStoreModule without storeModule`)
    }
    await requestModuleUse(this.$options.storeModule)
  }
}
